import { render, staticRenderFns } from "./sign-box.vue?vue&type=template&id=d942259e&scoped=true"
import script from "./sign-box.js?vue&type=script&lang=js&external"
export * from "./sign-box.js?vue&type=script&lang=js&external"
import style0 from "./sign-box.less?vue&type=style&index=0&id=d942259e&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d942259e",
  null
  
)

export default component.exports